module.exports = __webpack_public_path__ + "static/media/mars-stroke-h.bcba2acc.svg";